import { GeneralContextFactory } from './GeneralContextFactory';

export const generalContextDependencies = {
  generalInteractor: GeneralContextFactory.generalInteractor(),
};
